import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../../../assets/css/student/NgoScreen/HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      icon: '📝',
      number: '1',
      numberClass: 'hiw-num-blue',
      title: 'Student Submits Request',
      description:
        'Students submit applications with their documents, financial background, and educational proof for review.',
    },
    {
      icon: '🏛️',
      number: '2',
      numberClass: 'hiw-num-green',
      title: 'NGO Verifies Case',
      description:
        'Partner NGOs review and verify all documents through field visits and thorough case evaluation.',
    },
    {
      icon: '📱',
      number: '3',
      numberClass: 'hiw-num-orange',
      title: 'Donor Receives Verified Case',
      description:
        'Verified, trusted cases are forwarded to donors with full transparency and documentation for support.',
    },
  ];

  return (
    <section className="hiw-section" id="how-it-works">
      <Container>
        {/* Header */}
        <div className="hiw-header">
          <span className="hiw-section-label">Why Partner With Us</span>
          <h2 className="hiw-title">How the Process Works</h2>
          <p className="hiw-subtitle">
            Simple, transparent, and accountable — from student request to
            verified donation delivery.
          </p>
        </div>

        {/* Steps */}
        <Row className="g-4 justify-content-center">
          {steps.map((step, index) => (
            <Col xl={4} lg={4} md={6} sm={12} key={index}>
              <Card className="hiw-step-card">
                <Card.Body className="p-4">
                  <span className="hiw-step-icon">{step.icon}</span>
                  <div className={`hiw-step-num ${step.numberClass}`}>
                    {step.number}
                  </div>
                  <h5 className="hiw-step-title">{step.title}</h5>
                  <p className="hiw-step-desc">{step.description}</p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HowItWorks;